export default class AnotherDoc extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    events() {
        this.selectEvent();
        this.deleteEvent();
    }

    selectEvent() {
        this.querySelector('.type').addEventListener('change', (e) => {
            const type = e.target.value;

            if(type != '') {
                this.getFormVue(type, e);
            } else {
                this.addInView('<input type="text" disabled class="form-control pre-field" placeholder="Contenu">');
            }
        });
    }

    deleteEvent() {
        this.querySelector('.delete').addEventListener('click', (e) => {
            e.preventDefault();
            this.addInView('<input type="text" disabled class="form-control pre-field" placeholder="Contenu">');
            this.querySelector('.name').value = '';
            this.querySelector('.type').value = '';
        });
    }

    getFormVue($type, e) {
        const url = e.target.getAttribute('data-url');
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        this.$nbElement = document.querySelectorAll('.another-item');

        const formDatas = {
            type: $type,
            modelId: document.getElementById('model-id').value,
            count: e.target.getAttribute('data-count'),
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken // Include the CSRF token in the headers
            },
            body: JSON.stringify(formDatas)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Handle successful response data
                this.addInView(data.view);
            })
            .catch(error => {
                // Handle error
                toastr.error(error);
            });
    }

    addInView(view) {
        const insert = this.querySelector('.insert');
        this.$nbElement = document.querySelectorAll('.another-item');

        var child = document.createElement('div');
        child.innerHTML = view;
        insert.innerHTML = "";
        insert.append(child);
    }
}
